/**
 * A stable, random device id kept in localStorage and sent as X-Device-Id
 * on every API call. It carries no personal data; the backend stamps it on
 * orders and logins as dispute evidence (device continuity between a
 * purchase and the person who later claims the prize).
 */
const KEY = 'pv_device_id';

const generate = () => {
  if (window.crypto && typeof window.crypto.randomUUID === 'function') {
    return window.crypto.randomUUID().replace(/-/g, '');
  }
  const bytes = new Uint8Array(16);
  if (window.crypto && window.crypto.getRandomValues) {
    window.crypto.getRandomValues(bytes);
  } else {
    for (let i = 0; i < bytes.length; i += 1) {
      bytes[i] = Math.floor(Math.random() * 256);
    }
  }
  return Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
};

export const getDeviceId = () => {
  try {
    let id = window.localStorage.getItem(KEY);
    if (!id || !/^[a-z0-9]{16,64}$/i.test(id)) {
      id = generate();
      window.localStorage.setItem(KEY, id);
    }
    return id;
  } catch (e) {
    return null;
  }
};
